var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#704414",
    stroke: "url(#gift_svg__a)",
    strokeWidth: 0.2,
    d: "M15.327 19.43h-.1.1v-.01q0-.008-.002-.02a.7.7 0 0 0-.076-.273.55.55 0 0 0-.192-.214.65.65 0 0 0-.362-.096H4.218v.1-.1c-.886 0-1.61.724-1.61 1.61v11.33c0 .885.724 1.61 1.61 1.61v-.1.1h10.655c.107 0 .195-.03.263-.079a.43.43 0 0 0 .138-.17.6.6 0 0 0 .053-.21v-.023h-.1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#704414",
    stroke: "url(#gift_svg__b)",
    strokeWidth: 0.2,
    d: "M28.787 33.266v.1c.885 0 1.61-.724 1.61-1.61v-11.33c0-.885-.725-1.61-1.61-1.61v.1-.1H18.318a.66.66 0 0 0-.415.125.57.57 0 0 0-.19.276.9.9 0 0 0-.038.367v13.319a.4.4 0 0 0 .007.068c.007.04.02.098.05.156a.4.4 0 0 0 .147.165.5.5 0 0 0 .275.074h10.631z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#704414",
    stroke: "url(#gift_svg__c)",
    strokeWidth: 0.2,
    d: "M15.225 10.002h.1v-.009a1 1 0 0 0-.01-.087.7.7 0 0 0-.064-.204.55.55 0 0 0-.184-.215.6.6 0 0 0-.348-.097H2.51v.1-.1C1.624 9.39.9 10.114.9 11v4.712c0 .886.724 1.61 1.61 1.61v-.1.1h12.25c.268 0 .417-.12.493-.252a.55.55 0 0 0 .071-.242v-.008h-.1.1v-6.818z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#704414",
    stroke: "url(#gift_svg__d)",
    strokeWidth: 0.2,
    d: "M30.49 17.222v.1c.886 0 1.61-.724 1.61-1.61V11c0-.886-.724-1.61-1.61-1.61v.1-.1H18.241a.6.6 0 0 0-.323.085.5.5 0 0 0-.174.191.6.6 0 0 0-.07.26v.008h.1-.1v6.894h.098-.098v.01a1 1 0 0 0 .012.075.5.5 0 0 0 .078.17c.093.13.268.239.578.239H30.49z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#704414",
    stroke: "url(#gift_svg__e)",
    strokeWidth: 0.2,
    d: "M5.181 6.635c-.54-.765-.701-1.705-.49-2.784.184-.944.595-1.684 1.209-2.187C6.514 1.16 7.322.9 8.288.9c.408 0 .855.047 1.328.14zm0 0c.602.853 1.595 1.396 3.015 1.674.56.11 1.198.164 1.894.164 1.17 0 2.423-.158 3.44-.435l-.026-.096.026.096c1.5-.408 2.36-1.04 2.54-1.964m-10.889.56 10.89-.56m0 0c.061-.316.059-.728-.258-1.258-.313-.525-.931-1.16-2.09-1.937l-.056.083zM7.26 4.353c-.054.28-.045.462-.021.577.023.111.061.166.08.194h.002zm0 0c.069-.35.161-.548.305-.665s.36-.168.722-.168q.357 0 .826.09c1.305.256 2.878 1.18 3.768 1.891-.67.185-1.665.353-2.792.353-.523 0-1.005-.04-1.392-.117M7.262 4.353l1.436 1.384m0 0A4 4 0 0 1 7.8 5.47m.898.268L7.8 5.47m0 0c-.236-.108-.395-.226-.478-.344z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#704414",
    stroke: "url(#gift_svg__f)",
    strokeWidth: 0.2,
    d: "M24.837 8.309c-.56.11-1.198.164-1.894.164-1.17 0-2.422-.158-3.44-.435l.026-.096zm0 0c1.42-.278 2.413-.821 3.015-1.674.54-.765.701-1.705.49-2.784m-3.505 4.458 3.505-4.458m0 0c-.184-.944-.594-1.684-1.209-2.187C26.52 1.16 25.711.9 24.745.9c-.408 0-.855.047-1.328.14zm-11.38 2.223 6.455-5.034c-1.207.235-2.74.924-4.107 1.84-1.158.775-1.777 1.411-2.09 1.936-.317.53-.319.942-.257 1.258Zm3.19-.573c.885-.713 2.452-1.634 3.767-1.89q.468-.091.826-.091c.362 0 .578.051.722.168s.236.316.304.665c.055.28.047.462.023.577a.5.5 0 0 1-.082.194q-.125.182-.479.345a4 4 0 0 1-.898.268 7.5 7.5 0 0 1-1.392.117c-1.127 0-2.122-.168-2.792-.353Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gift_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(143.128 .254 14.18)scale(4.78179 14.0153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gift_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.82681 2.86918 -8.40846 -11.2149 24.034 25.372)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gift_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.34617 1.5459 -2.98039 -8.37915 8.112 12.969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gift_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.34614 1.54588 -2.98038 -8.37914 24.887 12.969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gift_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(156.878 4.734 3.217)scale(3.75443 8.27905)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gift_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.45283 1.47425 -3.25093 -7.61396 22.681 4.317)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755E1F"
  })))));
};
export default SvgGift;